import { createI18n } from 'vue-i18n';
import localeMessages from '../i18n/ko.json';

const instance = createI18n({
  legacy: false,
  locale: 'ko',
  fallbackLocale:'ko',
  messages: { ko: require('../i18n/ko.json') },
  warnHtmlMessage:false,
  globalInjection: true,
  silentFallbackWarn: false,
  fallbackWarn: false,
  missingWarn: false,
});

export default instance;

const i18n = instance.global;

const { t } = i18n;
const setLanguage = (locale: string) => {
  i18n.locale.value = locale;
  i18n.setLocaleMessage(locale, require(`../i18n/${locale}.json`));
};

const tHtml = (key: string, options?: any) => {
  const params = { em_s: '<em>', em_e: '</em>', br: '<br/>', ...options };
  return t(key, params);
};

export { i18n, setLanguage, tHtml };
